var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Tappable',_vm._g(_vm._b({class:_vm.classNames,attrs:{"component":_vm.componentName}},'Tappable',_vm.$attrs,false),_vm.$listeners),[_c('span',{staticClass:"ActionSheetItem__in"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }